import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"




export default /*#__PURE__*/_defineComponent({
  props: ['class'],
  setup(__props) {

const props = __props



return (_ctx: any,_cache: any) => {
  const _component_el_checkbox = _resolveComponent("el-checkbox")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["shop-check", props.class])
  }, [
    _createVNode(_component_el_checkbox, _normalizeProps(_guardReactiveProps(_ctx.$attrs)), {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 16)
  ], 2))
}
}

})